import type { CSSProperties } from 'react';
import { ProgressBar, type ProgressBarProps } from 'react-bootstrap';

const containerStyle: CSSProperties = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-around',
  marginLeft: '5px',
  marginRight: '5px',
  height: '100%',
};
const labelStyle: CSSProperties = {
  paddingLeft: '15px',
  fontSize: '0.9em',
};
const progressStyle: CSSProperties = { height: '6px' };

export function Progress({
  now,
  withLabel = false,
  variant = '',
}: {
  now: number;
  withLabel?: boolean;
  variant?: ProgressBarProps['variant'];
}) {
  return (
    <div style={containerStyle}>
      <ProgressBar
        now={now}
        style={{ ...progressStyle, width: withLabel ? '90%' : '100%' }}
        variant={variant}
      />
      {withLabel && <div style={labelStyle}>{now}%</div>}
    </div>
  );
}
